export default __webpack_public_path__ + "2c27b8f57c642ff156bf4449a08b428f.jpg";